import React, { useContext, useCallback } from "react";
import { ASSESSMENT_OBJECTIVE_REMARKS_FIELD_NAME } from "module/assessmentObjective/constants";
import TextareaField from "component/textareaField/TextareaField";
import XLabelField from "component/labelField/XLabelField";
import AssessmentObjectiveContext from "module/assessmentObjective/context/AssessmentObjectiveContext";
import AssessmentObjectiveChangeContext from "module/assessmentObjective/change/AssessmentObjectiveChangeContext";
import AssessmentObjectiveFieldMetaDataContext from "module/assessmentObjective/valiadation/fieldMetaData/AssessmentObjectiveFieldMetaDataContext";
import { AssessmentObjectiveInterface } from "module/assessment/types";
import { getFieldMetaDataWithErrorHandling } from "module/fieldMetaData/getFieldMetaData";

const AssessmentObjectiveRemarksFieldContainer: React.FC = () => {
  const { entity } = useContext(AssessmentObjectiveContext);
  const { change: changeHelper } = useContext(AssessmentObjectiveChangeContext);
  const { getFieldMetaData } = useContext(
    AssessmentObjectiveFieldMetaDataContext
  );

  const assessmentObjective = entity as AssessmentObjectiveInterface;

  const change = useCallback(
    (remarks?: string) => {
      changeHelper({ remarks });
    },
    [changeHelper]
  );

  const { warnings, errors, isEditable } = getFieldMetaDataWithErrorHandling(
    () => getFieldMetaData(ASSESSMENT_OBJECTIVE_REMARKS_FIELD_NAME)
  );

  return isEditable ? (
    <TextareaField
      {...{
        value: assessmentObjective.remarks,
        change,
        errors,
      }}
    />
  ) : (
    <XLabelField
      {...{ label: assessmentObjective.remarks, errors, warnings }}
    />
  );
};

export default React.memo(AssessmentObjectiveRemarksFieldContainer);
